import * as React from 'react';


export default class Print extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="Page-1" transform="translate(0.000000, 2.000000)">
            <g id="Group-14" transform="translate(0.000000, 0.117188)">
                <path d="M2.45740909,10.3125 L0.786272727,10.3125 C0.540136364,10.3125 0.341045455,10.1134091 0.341045455,9.86727273 L0.341045455,4.99090909 C0.341045455,4.74477273 0.540136364,4.54568182 0.786272727,4.54568182 L14.0149091,4.54568182 C14.2610455,4.54568182 14.4601364,4.74477273 14.4601364,4.99090909 L14.4601364,9.86727273 C14.4601364,10.1134091 14.2610455,10.3125 14.0149091,10.3125 L12.2162727,10.3125" id="Stroke-2"></path>
                <path d="M11.7332045,0 L3.06797727,0 C2.86411364,0 2.69911364,0.165 2.69911364,0.369545455 L2.69911364,4.54568182 L12.1020682,4.54568182 L12.1020682,0.369545455 C12.1020682,0.165 11.9370682,0 11.7332045,0 Z" id="Stroke-4"></path>
                <polygon id="Stroke-12" points="2.69863636 11.6761364 12.1022727 11.6761364 12.1022727 7.67045455 2.69863636 7.67045455"></polygon>
            </g>
        </g>
      </svg>
    )
  }
}
